import { IComponentController } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireTemplateSlotClass } from '../../../../../core/services/formulaire/formulaire-template-slot.service';

interface IPageAl2015 extends IComponentController {
    valeursEcran: any;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireDlt: IFormulaire;
    formulaireRes: IFormulaire;
}

/* @ngInject */
export default function Al0014Controller(
    Menu: IMenuClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireTemplateSlot: IFormulaireTemplateSlotClass,
    MenuItemAction: IMenuItemActionClass
) {
    const vm: IPageAl2015 = this;
    
        vm.valeursEcran = ecranDetails.valeurs;
        vm.menuBandeau = new Menu([]);
        vm.monoOccurrenceOptions = {
            //hideSaveAndNext: true,
            fonctions: {
                importation: true,
                afficherMenusDansEntete: true
            },
            menus: [
                new MenuItemAction(
                    'LBL_BTN_CALCULER',
                    'BTNCAL',
                    (data: any) => ({
                        dltcleint: data.dltcleint
                    }),
                    {
                        iconButton: false,
                        class: 'md-raised ex-button ex-button-action',
                        saveFirst: true,
                        successAction: () => {
                            vm.monoOccurrence.fetchData();
                        },
                        disabled: (data: any) => !data.dltdatvig
                    }
                )
            ]
        };
        vm.menuItem = new MenuItemAction(
            'LBL_BTN_GENERER',
            'BTNGEN',
            (data: any) => ({
                dalcleint: data.dalcleint,
                dltdatvig: data.dltdatvig
            }),
            {
                icon: 'sync',
                iconButton: false,
                saveFirst: true,
                successAction: () => {
                    vm.monoOccurrence.fetchData();
                },
                disabled: (data: any) => !data.dltdatvig ||!data.dltcleint
            }
        );
        vm.formulaireDlt = new Formulaire('LBL_BLC_DLT', [
            new FormulaireItem('dltdatvig', {
                largeur: 25,
                default: vm.valeursEcran.dltdat
            }),
            new FormulaireTemplateSlot('bouton', { largeur: 25 }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dltsalbas', { largeur: 20 }),
            new FormulaireItem('t_unccodsal', { largeur: 20, default: (data: any) => data.aut__unccodsal }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dlthresem', { largeur: 20 }),
            new FormulaireItem('dltsal14j', { largeur: 33 }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('t_dltsal14jmax', { largeur: 33, default: (data: any) => data.aut__sal14jmax }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dlthrejrs', { largeur: 33 }),
            new FormulaireItem('dltjrspay', { largeur: 33 })
        ]);    
}
